import React, { useCallback, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { updatePerson } from '../../../service/personService';
import { personValidator } from '../../../service/validatorForms';
import ImageUpload from '../../shared/ImageUpload';
import './EditPerson.css';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';


const EditPerson = () => {

    const { state } = useLocation();
    const { person, jobCategories: allJobCategories, areas: allAreas } = state;

    const [fullName, setFullName] = useState(person.fullName);
    const [code, setCode] = useState(person.code);
    const [jobCategories] = useState(allJobCategories);
    const [areas] = useState(allAreas);
    const [jobCategoryName, setJobCategoryName] = useState(person.jobCategoryName);
    const [jobCategoryId, setJobCategoryId] = useState(person.jobCategoryId);
    const [areaId, setAreaId] = useState(person.areaId);
    const [area, setArea] = useState(person.areaName);
    const [vocation, setVocation] = useState(person.vocation);
    const [vocationInfo, setVocationInfo] = useState(person.vocationInfo);
    const [mobileNumber, setMobileNumber] = useState(person.mobileNumber);
    const [age, setAge] = useState(person.age);
    const [telephone, setTelephone] = useState(person.telephone);
    const [address, setAddress] = useState(person.address);
    const [score, setScore] = useState(person.score);
    const [personImage, setPersonImage] = useState();
    const [vip, setVip] = useState(person.vip);
    const [discount, setDiscount] = useState(person.discountPercent);
    const [isLoading, setIsLoading] = useState(false);

    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);

    const validatorRef = useRef(personValidator());
    const {addToast} = useToasts();
    const history = useHistory();
    
    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                let newPerson = new FormData();
                newPerson.append('fullName', fullName);
                personImage && newPerson.append('personImage', personImage);
                newPerson.append('jobCategoryId', jobCategoryId);
                newPerson.append('jobCategoryName', jobCategoryName);
                newPerson.append('code', code);
                newPerson.append('areaId', areaId);
                newPerson.append('areaName', area);
                newPerson.append('vocation', vocation);
                newPerson.append('vocationInfo', vocationInfo);
                newPerson.append('discountPercent', Number(discount));
                newPerson.append('address', address);
                newPerson.append('telephone', telephone);
                newPerson.append('mobileNumber', mobileNumber);
                newPerson.append('age', age);
                newPerson.append('score', score);
                newPerson.append('vip', vip);
                setIsLoading(true);

                const { status } = await updatePerson(person._id, newPerson);
                if (status === 201) {
                    addToast("ویرایش با موفقیت انجام شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })

                    setIsLoading(false);

                    validatorRef.current.hideMessageFor("fullName");
                    validatorRef.current.hideMessageFor("jobCategoryId");
                    validatorRef.current.hideMessageFor("jobCategoryName");
                    validatorRef.current.hideMessageFor("code");
                    validatorRef.current.hideMessageFor("area");
                    validatorRef.current.hideMessageFor("vocation");
                    validatorRef.current.hideMessageFor("vocationInfo");
                    validatorRef.current.hideMessageFor("discount");
                    validatorRef.current.hideMessageFor("address");
                    validatorRef.current.hideMessageFor("telephone");
                    validatorRef.current.hideMessageFor("mobileNumber");
                    validatorRef.current.hideMessageFor("age");
                    validatorRef.current.hideMessageFor("score");
                    validatorRef.current.hideMessageFor("vip");
                    validatorRef.current.hideMessages();
                    forceUpdate()
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {

            if (err.response && err.response.status === 404) {
                addToast("شماره موبایل و یا کد متخصص قبلا ثبت شده است", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 422) {
                addToast("اطلاعات را کامل وارد کنید", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if(err.response && err.response.status === 401){
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            setIsLoading(false);
        }
    }


    const selectVipHandler = (event) => {
        if(event.currentTarget.checked){
            setVip(true)
        }
        else{
            setVip(false);
        }
    }
    const setJobCategoryHandler = (event) => {
        try {
            jobCategories.forEach(category => {
                if(String(category._id) === String(jobCategories[event.target.selectedIndex - 1]._id)){
                    setJobCategoryName(category.title);
                    setJobCategoryId(category._id)
                }
            })
        } catch (error) {}
    }
    const setAreaHandler = (event) => {
        try {
            areas.forEach(area => {
                if(String(area._id) === String(areas[event.target.selectedIndex - 1]._id)){
                    setArea(area.title);
                    setAreaId(area._id);
                }
            })
        } catch (error) {}
    }
    return ( 
        <React.Fragment>
            <div className="edit-person-container">
                <header >
                    <h1>ویرایش متخصص</h1>
                </header>
                <section>
                    <form onSubmit={submitHandler}>
                        <div className="form-row">
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="fullName323">
                                نام و نام خانوادگی
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="fullName323"
                                    placeholder="نام و نام خانوادگی"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    onBlur={() => {
                                        if (fullName !== '') {
                                            validatorRef.current.showMessageFor("fullName");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "fullName",
                                    fullName,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="code324">کد متخصص</label>
                                <input
                                    style={{ direction: "ltr", fontFamily:'Times New Romans' }}
                                    type="text"
                                    className="form-control"
                                    id="code324"
                                    placeholder="P101 : مثل"
                                    name="code"
                                    value={code}
                                    onChange={(e) => setCode(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (code !== '') {
                                            validatorRef.current.showMessageFor("code");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
                                />
                                {validatorRef.current.message(
                                    "code",
                                    code,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="inputState1">دسته شغلی</label>
                                <select id="inputState1" className="form-control "
                                    onChange={setJobCategoryHandler}
                                >
                                    <option  hidden>{jobCategoryName ? jobCategoryName : 'انتخاب کنید ...'}</option>
                                    {
                                        jobCategories.map((item) => (
                                            <option key={item._id}>
                                                {item.title}
                                            </option>
                                        ))
                                    }
                                </select>
                                {validatorRef.current.message(
                                    "jobCategoryName",
                                    jobCategoryName,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="type3">
                                شماره موبایل
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="type3"
                                    placeholder="شماره موبایل"
                                    value={mobileNumber}
                                    onChange={(e) => setMobileNumber(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (mobileNumber !== '') {
                                            validatorRef.current.showMessageFor("mobileNumber");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "mobileNumber",
                                    mobileNumber,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time5">تلفن ثابت</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time5"
                                    placeholder="تلفن ثابت"
                                    value={telephone}
                                    onChange={(e) => setTelephone(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (telephone !== '') {
                                            validatorRef.current.showMessageFor("telephone");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "telephone",
                                    telephone,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="inputState2">محدوده جغرافیایی</label>
                                <select id="inputState2" className="form-control "
                                    onChange={setAreaHandler}
                                >
                                    <option  hidden>{area ? area : 'انتخاب کنید ...'}</option>
                                    {
                                        areas.map(item => (
                                            <option key={item._id}>
                                                {item.title}
                                            </option>
                                        ))
                                    }
                                </select>
                                {validatorRef.current.message(
                                    "area",
                                    area,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time7">سن</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time7"
                                    placeholder="سن"
                                    value={age}
                                    onChange={(e) => setAge(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (age !== '') {
                                            validatorRef.current.showMessageFor("age");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "age",
                                    age,
                                    "required|integer"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time6">درصد تخفیف به مشتری</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time6"
                                    placeholder="درصد تخفیف به مشتری"
                                    value={discount}
                                    onChange={(e) => setDiscount(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (discount !== '') {
                                            validatorRef.current.showMessageFor("discount");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "discount",
                                    discount,
                                    "required|integer"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time81"> نمره (بین 0 تا 5 )</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time81"
                                    placeholder="نمره"
                                    value={score}
                                    onChange={(e) => setScore(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (score !== '') {
                                            validatorRef.current.showMessageFor("score");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "score",
                                    score,
                                    "required|numeric"
                                )}
                            </div>

                        </div>
                        <section >
                            <div className="d-flex flex-wrap justify-content-between">
                                <div className="form-group col-sm-6">
                                    <label htmlFor="time3">حرفه</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="time3"
                                        placeholder="حرفه"
                                        value={vocation}
                                        onChange={(e) => setVocation(e.target.value)}
                                        onBlur={() => {
                                            if (vocation !== '') {
                                                validatorRef.current.showMessageFor("vocation");
                                                forceUpdate();
                                            }
                                        }}
                                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                    />
                                    {validatorRef.current.message(
                                        "vocation",
                                        vocation,
                                        "required"
                                    )}
                                    <div className="mt-2 text-center">
                                        <label className="green-checkbox " style={{fontSize:'1.3rem'}}>
                                            <input
                                                type="checkbox"
                                                className="fill-control-input"
                                                id={`selectvip`} 
                                                checked={vip}
                                                onChange={selectVipHandler}
                                            />
                                            <span className="fill-control-indicator"></span>
                                            <small className="font-weight-bold">VIP</small>
                                        </label> 
                                    </div>
                                </div>
                                <div className="form-group col-sm-6 align-self-center px-0">
                                    <label htmlFor="exampleFormControlTextarea5">
                                        توضیحات درباره حرفه
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea5"
                                        rows="4"
                                        placeholder="در حد چند کلمه توضیح دهید"
                                        value={vocationInfo}
                                        name="vocationInfo"
                                        aria-describedby="description"
                                        onChange={ e => setVocationInfo(e.target.value)}
                                        onBlur={() => {
                                            if (vocationInfo !== '') {
                                                validatorRef.current.showMessageFor("vocationInfo");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "vocationInfo",
                                        vocationInfo,
                                        "required|min:15"
                                    )}
                                </div>

                            </div>
                        </section>
                        <div className="form-row">

                            <div className="col-12 col-sm-6  mt-1 form-group mx-auto ">
                                    <h5 className="font-weight-bold mt-3">عکس متخصص <small> ( کمتر از 200 کیلوبایت )</small></h5>
                                    <ImageUpload
                                        id="image_1"
                                        squar={true}
                                        editModeImageSrc={person.personImage}
                                        setFinalImage={(src) => setPersonImage(src)}
                                    />
                            </div>
                            <div className="form-group col-sm-6 align-self-center">
                                    <label htmlFor="exampleFormControlTextarea6">
                                        آدرس
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea6"
                                        rows="4"
                                        placeholder="آدرس"
                                        value={address}
                                        name="address"
                                        aria-describedby="description"
                                        onChange={ e => setAddress(e.target.value)}
                                        onBlur={() => {
                                            if (address !== '') {
                                                validatorRef.current.showMessageFor("address");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "address",
                                        address,
                                        "required|min:15"
                                    )}
                                </div>
                        </div>

                        <div className="text-center mt-4">
                            <button 
                                type="submit"
                                className="btn btn-success mr-1"
                                style={{ width: "100px" }}
                                disabled={isLoading}
                            >
                                <i 
                                    className={isLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                                    style={{position:'relative', bottom:'2px'}}
                                ></i>
                                ویرایش
                                
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                style={{ width: "100px" }}
                                onClick={() => history.replace('/dashboard/persons')}
                            >
                                بازگشت
                            </button>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>
     );
}
 
export default EditPerson;